import Login from './Login';
import Signup from './Signup';
import Forgot from './Forgot';
import ForgotConfirm from './ForgotConfirm';

const index = {
  Login,
  Signup,
  Forgot,
  ForgotConfirm,
};

export default index;